module.exports = __webpack_public_path__ + "img/IMG_0300_L_Black.8ec57504.jpg";